<template>
  <div class="kama-row">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@use '@/styles/variables.scss' as vars;

.kama-row {
	margin: -(vars.$kama-col-padding);
}
</style>
